import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAdminUser } from '../utils/auth.js';

export default function AdminRoute({ children }) {
  if (!isAdminUser()) {
    return <Navigate to="/home" replace />;
  }

  return children;
}
